import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BeneficiaryExceptionalRequestDto } from '../model/beneficiary-exceptional/beneficiary-exceptional.dto';
import { GenericResponseDto } from '../model/common/generic-response.dto';
import { firstValueFrom, Observable } from 'rxjs';
import { BeneficiaryExceptionalResponseDto } from '../model/beneficiary-exceptional/beneficiary-exceptional-response.dto';
import { ExceptionalFileBeneficiaryDto } from '../dto/exceptional-beneficiary/exceptional-file-beneficiary.dto';
import { ExceptionalFileDetailGridDto } from '../dto/exceptional-beneficiary/exceptional-file-detail.dto';

@Injectable({
  providedIn: 'root'
})
export class ExceptionalBeneficiaryService {

  private apiUrl = environment.apiBaseUrl;
  
  constructor(private http: HttpClient) { }

  async createExceptionalBeneficiary(requestDto: BeneficiaryExceptionalRequestDto): Promise<GenericResponseDto<BeneficiaryExceptionalResponseDto>>{
    return firstValueFrom(
      this.http.post<GenericResponseDto<BeneficiaryExceptionalResponseDto>>(
        `${this.apiUrl}${environment.services.exceptionalBeneficiary.createExceptionalBeneficiary}`, requestDto
      )
    )
  }

  getAllExceptionBeneficiaries(): Observable<GenericResponseDto<BeneficiaryExceptionalResponseDto[]>>{
    return this.http.get<GenericResponseDto<BeneficiaryExceptionalResponseDto[]>>(
      `${this.apiUrl}${environment.services.exceptionalBeneficiary.getListExceptionalBeneficiary}`
    )
  }

  checkIsExceptionalBeneficiary(documentNumber: string): Observable<GenericResponseDto<boolean>> {
    return this.http.get<GenericResponseDto<boolean>>(
      `${this.apiUrl}${environment.services.exceptionalBeneficiary.checkIsExceptionalBeneficiary(documentNumber)}`
    );
  }

  updateExceptionalBeneficiary(requestDto: BeneficiaryExceptionalRequestDto): Promise<GenericResponseDto<void>> {
   return firstValueFrom(
      this.http.patch<GenericResponseDto<void>>(
        `${this.apiUrl}${environment.services.exceptionalBeneficiary.updateExceptionalBeneficiary(requestDto.documentNumber)}`, requestDto
      )
   ) 
  }

  upload(file: File): Observable<GenericResponseDto<void>> {
        const formData = new FormData();

        formData.append('file', file);

        return this.http.post<GenericResponseDto<void>>(`${this.apiUrl}/exceptional-beneficiaries-massive-load/submit-file`, formData);
  }

  listAll(): Observable<GenericResponseDto<ExceptionalFileBeneficiaryDto[]>> {
          return this.http.get<GenericResponseDto<ExceptionalFileBeneficiaryDto[]>>(`${this.apiUrl}/exceptional-beneficiaries-massive-load/list-files`);
  }

  getById(id: string): Observable<GenericResponseDto<ExceptionalFileDetailGridDto[]>> {
          return this.http.get<GenericResponseDto<ExceptionalFileDetailGridDto[]>>(`${this.apiUrl}/exceptional-beneficiaries-massive-load/${id}/detail`);
  }

}
